import React, { Component, Fragment } from 'react'
import { Badge, Button, message, Tooltip } from 'antd'
import { sessionItemVal, strVal } from '../../../modules/Utils'
import Clients from '../../../api/Sales/Clients'
import Dropdowns from '../../../api/Dropdowns'
import ContractsApi from '../../../api/Sales/SalesContracts'
import { Link, withRouter } from 'react-router-dom'
import InfoText from '../../../elements/InfoText'
import { compose } from 'recompose'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import CustomTable from '../../../elements/Table/CustomTable'
import Status from '../../../elements/Status'
import State from '../../../elements/State'

const NewContractButton = withRouter(({ history, client, member }) => {
  return (
    <Button
      type="primary"
      icon={'plus'}
      size={'small'}
      onClick={() => {
        history.push({
          pathname: 'contracts/new',
          state: { client, member },
        })
      }}>
      New{' '}
    </Button>
  )
})

class ContractsCmp extends Component {
  constructor(props) {
    super(props)
    this.api = new Clients()
    this.contractApi = new ContractsApi()
    this.dropdownApi = new Dropdowns()
    this.key = props.client._key
    this.state = {
      key: '',
      contracts: [],
      fetching: false,
    }
  }

  columns = [
    {
      Header: 'Code',
      accessor: 'code',
      width: 150,

      Cell: ({ value, original }) => (
        <div>
          {original.default === true && (
            <Tooltip placement="top" title="Default Contract">
              <Badge
                dot
                style={{
                  background: '#2db731',
                }}
              />
            </Tooltip>
          )}
          <Link
            to={{
              pathname: `/clients/${this.props.member._key}/contracts/${original._key}/view`,
              state: {
                contract: original,
                client: this.props.client,
                member: this.props.member,
              },
            }}
            style={{ marginLeft: '10px' }}>
            {value}
          </Link>
        </div>
      ),
    },
    {
      Header: 'Type',
      accessor: 'type',
      width: 150,
    },
    {
      Header: 'Title',
      accessor: 'title',
      width: 300,
    },
    {
      Header: 'Company',
      accessor: 'company',
      Cell: ({ value }) => strVal(value, 'fn'),
      width: 500,
    },
    {
      Header: 'Services State',
      accessor: 'state',
      width: 150,

      Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
    },
    {
      Header: 'Billing State',
      accessor: 'billingState',
      width: 150,

      Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
    },
    {
      Header: 'Document Status',
      accessor: 'status',
      width: 150,

      Cell: ({ value }) => <Status value={value} tooltip={false} />,
    },
  ]

  async componentDidMount() {
    this.key = this.props.client._key
    if (this.key) {
      await this.fetch()
    }
  }

  fetch = async () => {
    try {
      this.setState({ fetching: true })
      const contracts = await this.api.contracts.list(this.key)
      contracts.sort(function (x, y) {
        return x.status === 'Approved' ? -1 : y.status === 'Approved' ? 1 : 0
      })
      const primaryContract = contracts.filter((c) => c.default === true)[0] || {}
      this.setState({
        contracts,
        primaryContract,
        fetching: false,
      })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }

  render() {
    const { client, member } = this.props
    return (
      <Fragment>
        <CustomTable
          CreateButton={() => <NewContractButton client={client} member={member} />}
          fetch={this.fetch}
          loading={this.state.fetching}
          columns={this.columns}
          data={this.state.contracts}
          pagination={false}
        />
        <InfoText text={'Click on contract code to view contract and Sales orders.'} />
      </Fragment>
    )
  }
}

export default compose(withLoadingSection, withRouter)(ContractsCmp)
